export default "__VITE_ASSET__BjCDDkIX__"